import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { ClassificacaoTipo } from '../classificacao-tipo';
import { ClassificacaoFilter } from '../../filter';
import { tipoClassificacaoCadastroCliente, tipoClassificacaoCadastroItem } from '../../../tipo-classificacao/cadastro';
import { ClassificacaoTipoHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-classificacao-tipo-multiselect',
    templateUrl: './classificacao-tipo-multiselect.component.html',
    styleUrls: ['./classificacao-tipo-multiselect.component.less']
})
export class ClassificacaoTipoMultiselectComponent implements OnInit, OnDestroy {
    /** Tipos das classificações selecionadas */
    @Input() idsTiposClassificacoes: number[];
    /** Ao alterar a seleção os tipos das classificações */
    @Output() idsTiposClassificacoesChange = new EventEmitter<number[]>();

    /** Classificações de itens selecionadas */
    @Input() idsClassificacoes: number[];
    /** Ao alterar a seleção das classificações */
    @Output() idsClassificacoesChange = new EventEmitter<number[]>();

    /** Se deve exibir a opção de selecionar a opção de classificação nula ou seja, para filtrar registros que não possuem a classificação */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar a classificação nula */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção da classificação nula */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    /** Se deve filtrar tipos das classificações de cadastro igual a Cliente */
    @Input() tipoClassificacaoCadastroCliente = false;
    /** Se deve filtrar tipos das classificações de cadastro igual a Item */
    @Input() tipoClassificacaoCadastroItem = false;

    /** Ao destruir o multiselect */
    @Output() onDestroy = new EventEmitter<void>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum segmento';
    @Input() checked = 'Segmento';
    @Input() checkedPlural = 'Segmentos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum segmento encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    tipos: ClassificacaoTipo[] = [];

    constructor(private messageService: MessageService,
                private classificacaoTipoHttpService: ClassificacaoTipoHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-classificacao-tipo ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria o filter para pesquisar as classificações */
    private createFilter(): ClassificacaoFilter {
        const filter = new ClassificacaoFilter();

        // Tipo de Classificação Cadastro Cliente
        if (this.tipoClassificacaoCadastroCliente) {
            filter.cadastrosTipoClassificacao.push(tipoClassificacaoCadastroCliente.id);
        }
        // Tipo de Classificação Cadastro Item
        if (this.tipoClassificacaoCadastroItem) {
            filter.cadastrosTipoClassificacao.push(tipoClassificacaoCadastroItem.id);
        }

        return filter;
    }

    /** Cria os tipos de itens para o multiselect */
    private create() {
        this.tipos = [];
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter  = this.createFilter();
        this.classificacaoTipoHttpService.search(filter)
            .pipe(
                take(1)
            )
            .subscribe(
                tipos => {
                    this.tipos = tipos;
                    // Adicionando os tipos e suas classificações ao multiselect
                    if (this.tipos) {
                        // Adicionando a opção de "Sem Segmento"
                        if (this.showNullOption) {
                            selects.push({
                                id: 0,
                                name: 'SEM SEGMENTO'
                            });
                        }

                        // Tipos
                        this.tipos.forEach(tipo => {
                            // Tipo
                            selects.push({
                                id: tipo.idTipoClassificacao,
                                name: tipo.nomeTipoClassificacao,
                                isLabel: true
                            });
                            // Classificações
                            tipo.classificacoes?.forEach(classificacao => {
                                selects.push({
                                    id: classificacao.id,
                                    name: classificacao.nome
                                });
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os segmentos', error);
                }
            );
    }


    /** Ao alterar os tipos de classificações d eitens */
    private onChangeIdsTiposClassificacoes() {
        this.idsTiposClassificacoes = [];
        for (let i = 0; i < this.tipos?.length; i++) {
            const tipo = this.tipos[i];
            tipoLoop: for (let j = 0; j < tipo.classificacoes?.length; j++) {
                const classificacao = tipo.classificacoes[j];
                if (this.idsClassificacoes?.includes(classificacao.id) && !this.idsTiposClassificacoes.includes(classificacao.idTipoClassificacao)) {
                    this.idsTiposClassificacoes.push(classificacao.idTipoClassificacao);
                    break tipoLoop;
                }
            }
        }

        this.idsTiposClassificacoesChange.emit(this.idsTiposClassificacoes);
    }

    /** Ao alterar a seleção da opção da natureza de venda nula */
    private onChangeNullOption() {
        this.nullOption = this.idsClassificacoes.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção das classificações */
    onChange() {
        this.onChangeIdsTiposClassificacoes();
        this.onChangeNullOption();
        this.idsClassificacoesChange.emit(this.idsClassificacoes);
    }

    ngOnDestroy() {
        this.onDestroy.emit();
    }
}
